
export type PostscriptTermFunction = "search" | "replace"
export const POSTSCRIPT_TERM_OPTIONS = ["search", "replace"];
export interface PostscriptTerm {
    id: number,
    school_id: string,
    term: string,
    expression: string,
    function: PostscriptTermFunction,
    source: string,
}

export type PostscriptCategoryCheck = "ExactlyOneCheck" | "OneOrMoreCheck"
export const POSTSCRIPT_CHECK_OPTIONS = ["ExactlyOneCheck", "OneOrMoreCheck"];
export interface PostscriptCategory {
    id: number,
    school_id: string,
    name: string,
    level: number,
    check: PostscriptCategoryCheck,
}

export interface NotificationExtra {
    school_id?: string
    event: string
    admins: boolean
    assignee: boolean
    collaborator: boolean
    committee_member: boolean
    owner: boolean
}

export interface PostscriptNotification {
    school_id: string
    send_new_assessments_to_faculty: boolean
    send_new_assessments_to_mentors: boolean
    include_quizzes: boolean
    notifications_extra: NotificationExtra[]
}